(function(){
  'use strict';

  if(window.SJWBenefits&&typeof window.SJWBenefits.init==='function'){
    window.SJWBenefits.init(document);
    return;
  }

  var ICO={
    labgrown:"<svg class=\"sjw-bn__ico\" viewBox=\"0 0 48 48\" aria-hidden=\"true\"><path d=\"M12 18 L24 6 L36 18 L24 42 Z\" stroke=\"#1B1A18\" stroke-width=\"1.6\" fill=\"none\" stroke-linejoin=\"round\"/><path d=\"M12 18H36M19 18L24 42M29 18L24 42\" stroke=\"#1B1A18\" stroke-width=\"1.2\"/><path d=\"M19 18 L24 6 L29 18 Z\" fill=\"#C2A878\"/></svg>",
    certified:"<svg class=\"sjw-bn__ico\" viewBox=\"0 0 48 48\" aria-hidden=\"true\"><path d=\"M24 6 L38 11 V24 C38 33 32 38 24 42 C16 38 10 33 10 24 V11 Z\" stroke=\"#1B1A18\" stroke-width=\"1.6\" fill=\"none\" stroke-linejoin=\"round\"/><path d=\"M24 16 l5 6 -5 9 -5 -9 z\" fill=\"#C2A878\"/></svg>",
    shipping:"<svg class=\"sjw-bn__ico\" viewBox=\"0 0 48 48\" aria-hidden=\"true\"><path d=\"M8 16 L24 8 L40 16 V32 L24 40 L8 32 Z\" stroke=\"#1B1A18\" stroke-width=\"1.6\" fill=\"none\" stroke-linejoin=\"round\"/><path d=\"M8 16 L24 24 L40 16 M24 24 V40\" stroke=\"#1B1A18\" stroke-width=\"1.3\"/><path d=\"M24 8 l4 5 -4 7 -4 -7 z\" fill=\"#C2A878\"/></svg>",
    returns:"<svg class=\"sjw-bn__ico\" viewBox=\"0 0 48 48\" aria-hidden=\"true\"><path d=\"M12 24 a12 12 0 1 1 4 9\" stroke=\"#1B1A18\" stroke-width=\"1.6\" fill=\"none\" stroke-linecap=\"round\"/><path d=\"M12 15 V24 H21\" stroke=\"#1B1A18\" stroke-width=\"1.6\" fill=\"none\" stroke-linejoin=\"round\"/><path d=\"M24 20 l4 4 -4 4 -4 -4 z\" fill=\"#C2A878\"/></svg>",
    duties:"<svg class=\"sjw-bn__ico\" viewBox=\"0 0 48 48\" aria-hidden=\"true\"><path d=\"M10 10 H26 L40 24 L26 38 H10 Z\" stroke=\"#1B1A18\" stroke-width=\"1.6\" fill=\"none\" stroke-linejoin=\"round\"/><circle cx=\"18\" cy=\"18\" r=\"2.3\" fill=\"#1B1A18\"/><path d=\"M22 26 l4 4 8 -9\" stroke=\"#C2A878\" stroke-width=\"2\" fill=\"none\" stroke-linecap=\"round\"/></svg>",
    warranty:"<svg class=\"sjw-bn__ico\" viewBox=\"0 0 48 48\" aria-hidden=\"true\"><path d=\"M16 24 a6 6 0 1 1 6 6 a6 6 0 1 0 6 -6 a6 6 0 1 1 -6 -6 a6 6 0 1 0 -6 6 Z\" stroke=\"#1B1A18\" stroke-width=\"1.6\" fill=\"none\"/><path d=\"M24 10 l3 4 -3 5 -3 -5 z\" fill=\"#C2A878\"/></svg>",
    secure:"<svg class=\"sjw-bn__ico\" viewBox=\"0 0 48 48\" aria-hidden=\"true\"><rect x=\"12\" y=\"21\" width=\"24\" height=\"18\" rx=\"2\" stroke=\"#1B1A18\" stroke-width=\"1.6\" fill=\"none\"/><path d=\"M17 21 v-4 a7 7 0 0 1 14 0 v4\" stroke=\"#1B1A18\" stroke-width=\"1.6\" fill=\"none\"/><path d=\"M24 27 l3 4 -3 5 -3 -5 z\" fill=\"#C2A878\"/></svg>",
    pricematch:"<svg class=\"sjw-bn__ico\" viewBox=\"0 0 48 48\" aria-hidden=\"true\"><circle cx=\"24\" cy=\"24\" r=\"15\" stroke=\"#1B1A18\" stroke-width=\"1.6\" fill=\"none\"/><path d=\"M24 15 v18 M20 19 h6 a3 3 0 0 1 0 6 h-4 a3 3 0 0 0 0 6 h6\" stroke=\"#C2A878\" stroke-width=\"1.8\" fill=\"none\" stroke-linecap=\"round\"/></svg>",
    madetoorder:"<svg class=\"sjw-bn__ico\" viewBox=\"0 0 48 48\" aria-hidden=\"true\"><path d=\"M14 22 L24 10 L34 22 L24 40 Z\" stroke=\"#1B1A18\" stroke-width=\"1.6\" fill=\"none\" stroke-linejoin=\"round\"/><path d=\"M14 22H34\" stroke=\"#1B1A18\" stroke-width=\"1.2\"/><path d=\"M24 28 v8 M20 32 h8\" stroke=\"#C2A878\" stroke-width=\"1.8\" stroke-linecap=\"round\"/></svg>",
    facet:"<svg class=\"sjw-bn__ico\" viewBox=\"0 0 48 48\" aria-hidden=\"true\"><path d=\"M24 6 L42 24 L24 42 L6 24 Z\" fill=\"#C2A878\"/><path d=\"M24 6 L42 24 L24 24 Z\" fill=\"#2C4A41\"/></svg>"
  };
  function key(t){t=(t||'').toLowerCase();
    if(/return/.test(t))return 'returns';
    if(/warrant/.test(t))return 'warranty';
    if(/dut/.test(t))return 'duties';
    if(/ship|worldwide|deliver/.test(t))return 'shipping';
    if(/price|match/.test(t))return 'pricematch';
    if(/secure|payment|safe|checkout/.test(t))return 'secure';
    if(/made|order|craft|atelier|bespoke|hand/.test(t))return 'madetoorder';
    if(/certif|igi|gra|graded/.test(t))return 'certified';
    if(/lab.?grown|conflict|ethic/.test(t))return 'labgrown';
    if(/promise|signora/.test(t))return 'facet';
    return null;}

  function getRoots(scope){
    var roots=[];
    scope=scope||document;
    if(scope.nodeType===1&&scope.matches&&scope.matches('.sjw-bnx'))roots.push(scope);
    if(scope.querySelectorAll){
      var found=scope.querySelectorAll('.sjw-bnx');
      for(var i=0;i<found.length;i++){
        if(roots.indexOf(found[i])===-1)roots.push(found[i]);
      }
    }
    return roots;
  }

  function replaceIcons(root){
    var items=root.querySelectorAll('.sjw-bn__item');
    for(var i=0;i<items.length;i++){
      var item=items[i];
      if(item.getAttribute('data-sjw-ico'))continue;
      var title=item.querySelector('.sjw-bn__ititle');
      var icon=item.querySelector('.sjw-bn__ico');
      if(!title||!icon)continue;
      var iconKey=key(title.textContent);
      if(iconKey&&ICO[iconKey]){
        icon.outerHTML=ICO[iconKey];
        item.setAttribute('data-sjw-ico','1');
      }
    }
  }

  function settle(root){
    var cs=getComputedStyle(root);
    var dur=parseFloat(cs.getPropertyValue('--bn-anim-dur'))||0.6;
    var stag=parseFloat(cs.getPropertyValue('--bn-stagger'))||100;
    var count=root.querySelectorAll('.sjw-bn__rv').length;
    clearTimeout(root.__sjwbnTimer);
    root.__sjwbnTimer=setTimeout(function(){
      root.classList.add('sjw-bn--settled');
    },dur*1000+stag*Math.max(0,count-1)+250);
  }

  function initSection(root){
    if(!root)return;
    replaceIcons(root);
    if(root.__sjwbn)return;
    root.__sjwbn=1;

    var reduce=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    if(reduce||!('IntersectionObserver' in window)){
      root.classList.add('in');
      root.classList.add('sjw-bn--settled');
      return;
    }

    var observer=new IntersectionObserver(function(entries){
      for(var i=0;i<entries.length;i++){
        if(entries[i].isIntersecting){
          root.classList.add('in');
          settle(root);
          observer.disconnect();
          root.__sjwbnObserver=null;
          break;
        }
      }
    },{threshold:.12});

    root.__sjwbnObserver=observer;
    observer.observe(root);
  }

  function init(scope){
    var roots=getRoots(scope);
    for(var i=0;i<roots.length;i++)initSection(roots[i]);
  }

  function destroy(scope){
    var roots=getRoots(scope);
    for(var i=0;i<roots.length;i++){
      var root=roots[i];
      if(root.__sjwbnObserver)root.__sjwbnObserver.disconnect();
      clearTimeout(root.__sjwbnTimer);
      root.__sjwbnObserver=null;
      root.__sjwbnTimer=null;
      root.__sjwbn=0;
    }
  }

  window.SJWBenefits={init:init,destroy:destroy};

  function boot(){
    init(document);
    setTimeout(function(){init(document);},400);
  }

  if(document.readyState!=='loading')boot();
  else document.addEventListener('DOMContentLoaded',boot,{once:true});

  document.addEventListener('shopify:section:load',function(event){
    init(event.target);
  });
  document.addEventListener('shopify:section:unload',function(event){
    destroy(event.target);
  });
})();

